export const SET_ONBOARD_MAP_CENTER = 'SET_ONBOARD_MAP_CENTER';
export const IMPORT_STEPS = 'IMPORT_STEPS';
export const CHECK_IMPORT_STEPS = 'CHECK_IMPORT_STEPS';
export const IMPORT_PREVIEW_STEPS = 'IMPORT_PREVIEW_STEPS';
